import { getMetadata, defineMetadata } from "./reflect-metadata-polyfill";
import { KEY_ORIGINAL_METHOD, KEY_BEFORE_METHOD, KEY_AFTER_METHOD, KEY_BEFORE_INSTANCE, KEY_AFTER_INSTANCE } from "./constants";
import { reflect } from "kaop";
function generateKey(scope, methodName) {
    return scope + "-" + methodName;
}
function wrapMethod(target, methodName, beforeKey, afterKey) {
    var keyOriginalMethod = generateKey(KEY_ORIGINAL_METHOD, methodName);
    return reflect.createProxyFn(target, methodName, (getMetadata(target, beforeKey) || []).concat([
        getMetadata(target, keyOriginalMethod)
    ], getMetadata(target, afterKey) || []));
}
function applyReflect(target, advices, methodName, keyJoinPoint, original) {
    var keyOriginalMethod = generateKey(KEY_ORIGINAL_METHOD, methodName);
    var adviceArr = getMetadata(target, keyJoinPoint) || [];
    adviceArr.push.apply(adviceArr, advices.map(reflect.advice));
    defineMetadata(target, keyJoinPoint, adviceArr);
    if (!getMetadata(target, keyOriginalMethod))
        defineMetadata(target, keyOriginalMethod, original);
    if (methodName === "constructor") {
        var keyBeforeInstance = generateKey(KEY_BEFORE_INSTANCE, methodName);
        var keyAfterInstance = generateKey(KEY_AFTER_INSTANCE, methodName);
        var result = wrapMethod(target, methodName, keyBeforeInstance, keyAfterInstance);
        result.prototype = target.prototype;
        return result;
    }
    else {
        var keyBeforeMethod = generateKey(KEY_BEFORE_METHOD, methodName);
        var keyAfterMethod = generateKey(KEY_AFTER_METHOD, methodName);
        return wrapMethod(target, methodName, keyBeforeMethod, keyAfterMethod);
    }
}
export function beforeMethod() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName, descriptor) {
        var keyBeforeMethod = generateKey(KEY_BEFORE_METHOD, methodName);
        descriptor.value = applyReflect(target, advices, methodName, keyBeforeMethod, descriptor.value);
        return descriptor;
    };
}
export function afterMethod() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName, descriptor) {
        var keyAfterMethod = generateKey(KEY_AFTER_METHOD, methodName);
        descriptor.value = applyReflect(target, advices, methodName, keyAfterMethod, descriptor.value);
        return descriptor;
    };
}
export function beforeInstance() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName) {
        if (methodName === void 0) { methodName = "constructor"; }
        var keyBeforeInstance = generateKey(KEY_BEFORE_INSTANCE, methodName);
        target = applyReflect(target, advices, methodName, keyBeforeInstance, target);
        return target;
    };
}
export function afterInstance() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName) {
        if (methodName === void 0) { methodName = "constructor"; }
        var keyAfterInstance = generateKey(KEY_AFTER_INSTANCE, methodName);
        target = applyReflect(target, advices, methodName, keyAfterInstance, target);
        return target;
    };
}
//# sourceMappingURL=decorators.js.map